import { connect } from 'react-redux';
import { ILocation } from '../../../api/locations';
import { IGeoSuggestItem } from '../../../common/components/geo_suggest';
import { IAppState, Dispatch } from '../../../common/state';
import { requestAutocomplete, selectAutocompleteSuggestion } from '../../state/location_switcher';
import { LocationSwitherAutocomplete } from './index';

export const LocationSwitherAutocompleteContainer = connect(
  (state: IAppState) => {
    return {
      suggestions: state.filters.locationSwitcher.autocompleteSuggestions,
      loading: state.filters.locationSwitcher.isAutocompleteLoading,
    };
  },
  (dispatch: Dispatch) => ({
    onValueChange: (value: string) => {
      dispatch(requestAutocomplete(value));
    },
    onSelect: (suggestion: IGeoSuggestItem<ILocation>) => {
      dispatch(selectAutocompleteSuggestion(suggestion.value));
    },
  }),
)(LocationSwitherAutocomplete);
